import React from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { Server, LayoutDashboard, Database, CreditCard, Globe, Plus, LogOut, Activity } from 'lucide-react';
import Overview from './pages/Overview';
import Schools from './pages/Schools';
import SchoolDetail from './pages/SchoolDetail';
import DeploySchool from './pages/DeploySchool';
import Backups from './pages/Backups';
import Billing from './pages/Billing';
import Domains from './pages/Domains';
import Login from './pages/Login';
import './App.css';

function isAuthenticated() {
  return !!localStorage.getItem('wyzcon_token');
}

function Sidebar() {
  const links = [
    { to: '/', icon: <LayoutDashboard size={18} />, label: 'Overview' },
    { to: '/schools', icon: <Server size={18} />, label: 'Schools' },
    { to: '/deploy', icon: <Plus size={18} />, label: 'Deploy New' },
    { to: '/backups', icon: <Database size={18} />, label: 'Backups' },
    { to: '/billing', icon: <CreditCard size={18} />, label: 'Billing' },
    { to: '/domains', icon: <Globe size={18} />, label: 'Domains' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('wyzcon_token');
    localStorage.removeItem('wyzcon_refresh');
    window.location.href = '/login';
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <div className="sidebar-logo">🧙‍♂️</div>
          <h1>Wyzcon</h1>
        </div>
        <span className="sidebar-subtitle">Infrastructure</span>
      </div>

      <nav className="sidebar-nav">
        {links.map(({ to, icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            {icon}
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-server-status">
        <span className="server-status-dot online" />
        <span className="server-status-label">Server Online</span>
        <span className="server-status-ip">178.156.210.82</span>
      </div>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="nav-link">
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}

function ProtectedRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <div className="app-layout">
                <Sidebar />
                <main className="main-content">
                  <Routes>
                    <Route path="/" element={<Overview />} />
                    <Route path="/schools" element={<Schools />} />
                    <Route path="/schools/:schoolId" element={<SchoolDetail />} />
                    <Route path="/deploy" element={<DeploySchool />} />
                    <Route path="/backups" element={<Backups />} />
                    <Route path="/billing" element={<Billing />} />
                    <Route path="/domains" element={<Domains />} />
                  </Routes>
                </main>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
